"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;

var _Provider = _interopRequireDefault(require("./components/Provider"));

exports.Provider = _Provider["default"];

var _connectAdvanced = _interopRequireDefault(require("./components/connectAdvanced"));

exports.connectAdvanced = _connectAdvanced["default"];

var _Context = require("./components/Context");

exports.ReactReduxContext = _Context.ReactReduxContext;

var _connect = _interopRequireDefault(require("./connect/connect"));

exports.connect = _connect["default"];

var _useDispatch = require("./hooks/useDispatch");

exports.useDispatch = _useDispatch.useDispatch;
exports.createDispatchHook = _useDispatch.createDispatchHook;

var _useSelector = require("./hooks/useSelector");

exports.useSelector = _useSelector.useSelector;
exports.createSelectorHook = _useSelector.createSelectorHook;

var _useStore = require("./hooks/useStore");

exports.useStore = _useStore.useStore;
exports.createStoreHook = _useStore.createStoreHook;

var _shallowEqual = _interopRequireDefault(require("./utils/shallowEqual"));

exports.shallowEqual = _shallowEqual["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/lib/exports.js
// module id = 120
// module chunks = 0